export enum MediaTypeEnum {
  VIDEO_ONLY,
  AUDIO_ONLY,
  BOTH,
}
